import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=d82ba968&"
import script from "./datatable.vue?vue&type=script&lang=js&"
export * from "./datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports